export default "__VITE_ASSET__Ciz0vl3o__"